import { UserData } from '@state/templates/types';
import { IAsyncAction, IAction } from '@state/types';
import { IBrandImageType } from '@state/dsconfig/types';

export const AdditionalMetadaTypesArray = [
  'year',
  'make',
  'model',
  'trim',
] as const;

export type AdditionalMetadataLiteral = typeof AdditionalMetadaTypesArray[number];

export type IAdditionalMetadata = {
  [k in AdditionalMetadataLiteral]?: string;
}

/* Data models */

export interface IBrandImage {
  id: string;
  entityType: string;
  imageType: string;
  brandId: string;
  brandName?:string;
  srcImage: string;
  format: string;
  types?: IType[];
  themes?: IType[];
  tags: string[];
  status: string;
  name: string;

  templatesCount: number;
  designsCount: number;
  actions: IActionInfo[];

  year?: string;
  make?: string;
  model?: string;
  trim?: string;

  createdBy?: any;
  updatedBy?: any;

  width?: number;
  height?: number;
  initWidth?: number;
  initHeight?: number;
}

export interface IBrandLogo{
  id:string
  name:string
  logotype?:string
  images:IBrandImage[];
}

export interface IBrandImagesOem{
  id:string
  name:string
  itype?:string
  metadata?:string
  lastlevel:boolean
  images:IBrandImage[];
}


export interface IActionInfo {
  user:UserData
  date:Date
  action:string  // CREATE | UPDATE | DELETE
  fileBackup?: string;
}

export interface IType {
  id: string;
  value: string;
  types?: IType[];
}

export interface Field {
  field: string;
  value: any;
}
export interface UpdateInfo {
  filter: string;
  fields: Field[];
}

export interface IAddEditBrand {
  id: string | null;
  newBrand?: boolean;
  oem: boolean | null;
  status? : string;
  name? : string;
  createdBy?: any;
  updatedBy: any;
  elementsUpdate?: IElementUpdate[];
}

export interface IElementUpdate {
  value: IBrandImage;
}

export interface IBrandChromeData{
  width:string
  height:string
  href:string
  background:string
  exactMatch:string

}

export interface IOemFilter {
  id: string;
  types: IType[];
  typesVehicles?: IBrandImageType[];
}

/* Reducer types */
export interface IBrandsImagesState {
  brandImages?: IBrandImage[];
  brandImagesSearch?: IBrandImage[];
  brandImagesSection?: IBrandImage[];
  filtersLogos?: IOemFilter[];
  filtersBackgrounds?: IOemFilter[];
  filtersStocks?: IOemFilter[];
  counterBrandImages?: {};
  counterBrandImagesSearch?: {};
}

/* Actions types */
export interface IFetchBrandImagesAction extends IAsyncAction {
  query?: string;
  start?:number;
  length?:number;
  update?: string;
}

export interface IFetchBrandImagesFiltersAction extends IAsyncAction {
  typestate: string;
  query?: string;
}

export interface IPostBrandImagesAction extends IAsyncAction {
  brandImages: IBrandImage[];
}

export interface IUpdateBrandImagesAction extends IAsyncAction {
  brandImages: IBrandImage[];
}

export interface IFetchBrandImagesAction extends IAsyncAction {
  query?: string;
}

export interface IFetchBrandImageAction extends IAsyncAction {
  id: string;
}


export interface IFetchBrandsVehiclesAction extends IAsyncAction {
  query?: string;
  year: string;
  make: string;
  model: string;
  trim:string;
  imgtype:string;
  start:number;
  length:number;
  oem?:string;
  search?: string;
  userdata?:string
}

export interface IFetchBrandsVehiclesChromeDataAction extends IAsyncAction {
  query?: string;
  year: string;
  make: string;
  model: string;
  trim:string;
  imgtype:string;  
}

export interface ISetBrandImage extends IAction {
  image: IBrandImage;
}

export interface ISetBrandImages extends IAction {
  brandImages: IBrandImage[];
}

export interface IFetchBrandsLogosAction extends IAsyncAction {
  oem?: string;  
  logotype?:string;
}

export interface ISetBrandLogos extends IAction {
  id:string
  name:string;
  logotype?:string;
  images: IBrandImage[];
}

export interface ISetBrandImagesFilters extends IAction {
  filters?: IOemFilter[];
  typestate?: string;
}


export interface IGetExternalImageAction extends IAsyncAction {
  url?: string;  
}


export interface IFetchBrandsImagesOemAction extends IAsyncAction {
  oem?: string;
  imageType?:string
  metadata?:string  
}

export interface ISetBrandImagesOem extends IAction {
  id:string
  name:string;
  itype?:string;
  images: IBrandImage[];
}

export interface IFetchCounterAction extends IAsyncAction {
  filter?: string;
  typestate?: string;
}

export interface ISetBrandImagesCountersAction extends IAction {
  counter: {};
}

export interface ISetCounterAction extends IAction {
  counterBrandImages: any;
  typestate?: string;
}